import Image from 'next/image';
import { FC } from 'react';
import { LoadOnHoverIframe } from '../../box';
import lidarIframePlaceholderSrc from 'react-scale/public/static/images/homepage/lidar-iframe-placeholder.jpeg';

export const Tab3D: FC = () => {
  return (
    <div className="bg-black relative w-full lg:absolute lg:top-1/2 lg:-translate-y-1/2 lg:translate-x-10 3xl:translate-x-18 transition-transform duration-1000 ease-out rounded-lg shadow-xl xl:shadow-super overflow-hidden lg:mb-0 mb-9 lg:w-1/2 xl:w-[649px] xl:h-[402px] select-none aspect-[649/402] min-w-full lg:min-w-[50%] xl:min-w-[unset] max-w-max">
      <LoadOnHoverIframe
        src={`https://lidar-now.scale.com/scene?title=${encodeURIComponent('Scene #1')}`}
        placeholder={
          lidarIframePlaceholderSrc ? (
            <Image src={lidarIframePlaceholderSrc} alt="" className="w-full h-full object-cover" />
          ) : null
        }
      />
    </div>
  );
};
